export default class StatisticsService {
  constructor(host, token, widgets, widgetIndex) {
    this.host = host
    this.token = token

    this.mlWhen = this.mlWhat = 'none'
    try {
      if (widgets.length > 0) {
        this.mlWhen = widgets[widgetIndex].mlWhen
        this.mlWhat = widgets[widgetIndex].mlWhat
      }
    } catch (e) {}
  }

  trackEvent(eventData) {
    if (!this.host) return

    fetch(`${this.host}/event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.token}`,
      },
      body: JSON.stringify(eventData),
    })
  }

  sendWebRTCStats(stats) {
    fetch(`${this.host}/webrtc-stats`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.token}`,
      },
      body: JSON.stringify(stats),
    })
  }

  trackPageVisit(accountId, widgetId, visitorId, country) {
    this.trackEvent({
      visitor_id: visitorId,
      event_type: 'page_visit',
      country: country,
      ml_when: this.mlWhen,
      ml_what: this.mlWhat,
    })
  }

  trackWidgetEvent(accountId, widgetId, visitorId, country, communicationChannel, eventType) {
    this.trackEvent({
      visitor_id: visitorId,
      event_type: eventType,
      channel: communicationChannel,
      country: country,
      ml_when: this.mlWhen,
      ml_what: this.mlWhat,
    })
  }
}
